import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { z } from 'zod';
import { PERMISSION_REFUELING_CARDS } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import Form from '../../components/FuelCards/Form';
import { URL_FUEL_CARDS } from '../../router/constants';

const editFuelCardSearchSchema = z.object({
  customerId: z.coerce.number().optional(),
});

export const Route = createFileRoute('/_authenticated/fuel_cards/edit/$id')({
  validateSearch: editFuelCardSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_REFUELING_CARDS, ['read'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.detail',
        suffix: 'menu.fuelCardsOverview',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: EditFuelCardRoute,
});

function EditFuelCardRoute() {
  const { id } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    navigate({ to: URL_FUEL_CARDS });
  }, [navigate]);

  return <Form id={Number(id)} customerId={search.customerId ?? null} handleClose={handleClose} />;
}
